import { useState, FormEvent } from "react";
import { API_ENDPOINTS } from "../../constants/constants";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      const response = await fetch(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erreur lors de la demande");
      }

      // En cas de succès
      setSuccess(true);
      console.log("Demande de réinitialisation envoyée:", data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Une erreur est survenue");
      console.error("Erreur:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-gray-800 relative overflow-hidden">
      {/* Image de fond (clavier et mains) - plus sombre et nette */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="/images/login.jpeg"
          alt="Fond avec clavier et mains"
          className="w-full h-full object-cover contrast-125 brightness-20"
        />
      </div>

      {/* Overlay semi-transparent plus foncé */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Contenu principal avec formulaire décalé à gauche sur desktop, centré sur mobile */}
      <div className="relative z-10 flex flex-col items-center sm:items-start justify-center min-h-screen px-4 sm:px-8 md:px-16 md:pl-32">
        {/* Formulaire de réinitialisation de mot de passe */}
        <div className="w-full max-w-xs sm:max-w-sm md:max-w-md bg-white/20 backdrop-blur-md p-4 sm:p-6 md:p-8">
          {/* Logo GuidePro */}
          <div className="mb-4 sm:mb-6">
            <h1 className="text-white text-3xl sm:text-4xl font-bold tracking-wider text-center">
              <span>Guide</span>
              <span className="font-light">pro</span>
            </h1>
          </div>
          <h2 className="text-white text-center text-sm sm:text-base mb-4 sm:mb-6">
            Mot de passe oublié
          </h2>

          {error && (
            <div className="bg-red-500/80 text-white p-3 mb-4 text-sm">
              {error}
            </div>
          )}

          {success ? (
            <div className="bg-green-500/80 text-white p-3 mb-4 text-sm">
              Un email de réinitialisation a été envoyé à votre adresse email.
            </div>
          ) : (
            <form className="space-y-4 sm:space-y-6" onSubmit={handleSubmit}>
              {/* Champ Email */}
              <div>
                <label
                  htmlFor="email"
                  className="block text-white text-xs sm:text-sm mb-1"
                >
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="Adresse email"
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 bg-white/30 border border-white/50 text-white placeholder-white/70 text-sm"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {/* Bouton d'envoi */}
              <div className="text-center mt-6">
                <button
                  type="submit"
                  className="bg-[#26853d] hover:bg-green-700 text-white font-bold px-4 sm:px-6 py-2 sm:py-3 rounded-xs uppercase text-xs sm:text-sm"
                  disabled={loading}
                >
                  {loading ? "Envoi en cours..." : "Envoyer"}
                </button>
              </div>
              <h2 className="text-white text-center text-sm sm:text-base mb-4 sm:mb-6">
                <Link to="/login">Retour à la connexion</Link>
              </h2>
            </form>
          )}
        </div>

        {/* Espace fixe de 2cm (environ 75px) sur mobile uniquement, caché sur desktop */}
        <div className="h-[1cm] block sm:hidden"></div>

        {/* Logo ministère en bas sur mobile, en bas à droite sur desktop */}
        <div className="w-full flex justify-center sm:justify-end sm:absolute sm:bottom-4 sm:right-4">
          <div className="text-white text-center">
            {/* Petite image/logo au-dessus du texte */}
            <div className="mb-1 sm:mb-3 flex justify-center">
              <img
                src="/images/armoirie-login.png"
                alt="Logo ministère"
                className="w-[50px] h-auto "
              />
            </div>
            <div className="text-xxs sm:text-xs leading-tight">
              MINISTÈRE DE LA FONCTION
              <br />
              PUBLIQUE ET DE LA MODERNISATION
              <br />
              DE L'ADMINISTRATION
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
